import { UserStore } from 'src/stores/UserStore/UserStore';

export const getCurrentUser = () => UserStore;
